import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentDetailsComponent } from './component/supplementary-equipment-details.component';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, CommonUIFieldsModule, CommonUIFormularModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    SupplementaryEquipmentDetailsComponent
  ],
  imports: [
    CommonModule,
    CommonUIFieldsModule,
    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatFormFieldModule,
    MatSelectModule,
  ], exports: [
    SupplementaryEquipmentDetailsComponent
  ]
})
export class SupplementaryEquipmentDetailsModule { }
